<mat-toolbar>
    <mat-toolbar-row>
        <div class="toolbar-left">
            <div class="background-overlay"></div>
            <img class="logo"
                 [src]="logoPath"
                 alt="Logo"
                 (click)="onTopBarLogoClick()">
            <button mat-icon-button
                    (click)="menuToggled.emit()">
                <mat-icon>menu</mat-icon>
            </button>
        </div>

        <div class="content-left">
            <ng-content select=".content-left"></ng-content>
        </div>
        <span class="toolbar-spacer"></span>
        <div class="toolbar-right">

            <ng-content></ng-content>
            <span></span>

            <!-- Clean -->
            <button mat-icon-button *ngIf="cleanConfig?.showCleanButton"
                    color="primary"
                    class="topbar-button"
                    (click)="lockForCleaning()">
                <mat-icon class="cleaning-icon">soap</mat-icon>
            </button>

            <!-- Fullscreen -->
            <button mat-icon-button
                    color="primary"
                    class="topbar-button"
                    (click)="requestFullscreen()">
                <mat-icon>{{ doc.fullscreenElement ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
            </button>

            <div (click)="clickedWPC()"
                 *ngIf="workplaceKey != null">
                <span class="workplace">{{ workplaceKey }}</span>
            </div>

            <ng-container *ngIf="username != null">
                <mat-divider class="custom-mat-divider"
                             [vertical]="true"></mat-divider>
                <button mat-button
                        class="menu-btn"
                        [matMenuTriggerFor]="menu">
                    {{ username }}
                    <mat-icon>expand_more</mat-icon>
                </button>

                <mat-menu #menu="matMenu" xPosition="before">
                    <ng-content select=".menu-right"></ng-content>

                    <button (click)="openProfileDialog()" *ngIf="showProfile"
                            class="menu-item"
                            mat-menu-item>
                        <mat-icon>person</mat-icon>
                        <span>{{ 'sla.ui-material.profile.label' | translate }}</span>
                    </button>

                    <button (click)="openVersionDialog()" *ngIf="packageJson"
                            class="menu-item"
                            mat-menu-item>
                        <mat-icon>info</mat-icon>
                        <span>{{ 'sla.ui-material.version.label' | translate }}</span>
                    </button>

                    <button (click)="refresh()" *ngIf="showRefresh"
                            class="menu-item"
                            mat-menu-item>
                        <mat-icon>refresh</mat-icon>
                        <span>{{ 'sla.ui-material.refresh.label' | translate }}</span>
                    </button>

                    <button (click)="logout()" *ngIf="showLogout"
                            class="menu-item"
                            mat-menu-item>
                        <mat-icon>logout</mat-icon>
                        <span>{{ 'sla.ui-material.logout.label' | translate }}</span>
                    </button>
                </mat-menu>
            </ng-container>

        </div>

        <div class="loading-indicator"
             *ngIf="showProgressBar">
            <mat-progress-bar color="accent"
                              mode="indeterminate"></mat-progress-bar>
        </div>

    </mat-toolbar-row>
</mat-toolbar>
